"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOCKTAKE = void 0;
var STOCKTAKE = {
  BUTTON__DATE_PICKER: 'stocktakes-button-datePicker',
  BUTTON__CONDUCT_STOCKTAKE: 'stocktakes-button-conductStocktake',
  ROW__SINGLE_STOCKTAKE: 'stocktakes-tr-singleStocktake',
  TEXT__USER: 'stocktakes-span-user',
  TEXT__WAREHOUSE: 'stocktakes-span-warehouse',
  TEXT__DATE: 'stocktakes-span-createdAt',
  TEXT__NOTE: 'stocktakes-span-note'
};
exports.STOCKTAKE = STOCKTAKE;